import clsx from 'clsx';
import { dataAttr } from '@vtmn-play/utils';

const DEFAULT_SIZE = "medium";
const DEFAULT_VARIANT = "primary";
const DEFAULT_VARIANT_STYLE = "regular";
const DEFAULT_SHAPE = "rounded";
const DEFAULT_TYPE = "button";
const DEFAULT_LOADING_SR_TEXT = "Loading...";
function VpButtonConnect(props, normalizeProps) {
  const {
    id,
    type = DEFAULT_TYPE,
    size = DEFAULT_SIZE,
    disabled = false,
    loading = false,
    variant = DEFAULT_VARIANT,
    variantStyle = DEFAULT_VARIANT_STYLE,
    _iconOnly = false,
    shape = DEFAULT_SHAPE,
    href,
    loadingScreenReaderText,
    _basename
  } = props;
  const isLink = typeof href === "string" && href !== undefined && href !== "";
  const isDisabled = disabled;
  const isLoading = loading;
  const dataAttrs = {
    "data-disabled": dataAttr(isDisabled),
    "data-loading": dataAttr(isLoading)
  };
  const basename = _basename || (_iconOnly ? "vp-icon-button" : "vp-button");
  return {
    /**
     * Whether the Button is disabled
     */
    isDisabled,
    /**
     * Whether the Button is loading
     */
    isLoading,
    /**
     * Whether the Button is only an icon
     */
    isIconOnly: _iconOnly,
    /**
     * DOM props
     */
    getRootProps() {
      return normalizeProps({
        ...dataAttrs,
        id,
        class: clsx(
          basename,
          size && size !== DEFAULT_SIZE && `${basename}--${size}`,
          _iconOnly && `${basename}--icon`,
          variant && variant !== DEFAULT_VARIANT && `${basename}--${variant}`,
          variantStyle && variantStyle !== DEFAULT_VARIANT_STYLE && `${basename}--${variantStyle}`,
          shape && shape !== DEFAULT_SHAPE && `${basename}--${shape}`
        ),
        "data-part": "button",
        /**
         * HTML Button <button /> only props
         */
        ...!isLink ? {
          type,
          disabled: isDisabled ? " " : undefined
        } : {},
        /**
         * HTML Link (<a />) only props
         */
        ...isLink ? {
          /**
           * Only native HTML button can have a `disabled` attribute.
           * To disable a link we need to:
           * - remove the `href` attribute
           * - add a role="link" so that it is always considered a link by screen readers
           * - add an attribute aria-disabled="true" so that it is indicated as being disabled
           */
          href: isDisabled ? undefined : href,
          role: isDisabled ? "link" : undefined,
          "aria-disabled": isDisabled ? "true" : undefined
        } : {}
      });
    },
    getLabelProps() {
      return normalizeProps({
        ...dataAttrs,
        class: `${basename}__label`,
        "data-part": "label"
      });
    },
    getStartSlotProps() {
      return normalizeProps({
        "data-part": "start-slot"
      });
    },
    getEndSlotProps() {
      return normalizeProps({
        "data-part": "end-slot"
      });
    },
    getLoadingSlotProps() {
      return normalizeProps({
        role: "status",
        "aria-live": "polite",
        "data-part": "loading-slot"
      });
    },
    getLoaderProps() {
      return normalizeProps({
        size,
        // @TODO: this will be reworked with designers
        variantStyle: variantStyle === "regular" && (variant === "secondary" || variant === "tertiary") || variantStyle === "inverse" && (variant === "primary" || variant === "negative") ? "regular" : "inverse",
        "data-part": "loader",
        "aria-label": loadingScreenReaderText ?? DEFAULT_LOADING_SR_TEXT
      });
    }
  };
}

export { VpButtonConnect };
